import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const ConstructionFormView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/ConstructionFormView.vue')
const ConstructionListView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/ConstructionListView/ConstructionListView.vue')
const ConstructionItemView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/ConstructionItemView.vue')
const PlanificationListView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/PlanificationListView/PlanificationListView.vue')
const MyPlanificationListView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/MyPlanificationListView/MyPlanificationListView.vue')
const ConstructionCalendarView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/ConstructionCalendarView.vue')
const TechniciansCalendarView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/TechniciansCalendarView.vue')
const MyCalendarView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/MyCalendarView.vue')
const TechnicianDashboardView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/TechnicianDashboardView.vue')

const routes: (i18n: VueI18n) => RouteConfig[] = () => {
  return [
    {
      path: '/constructions/constructions',
      name: 'construction-list',
      component: ConstructionListView,
      meta: {
        pageHeader: false,
        userPermission: ['construction', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/constructions/form/:id?',
      name: 'construction-form',
      component: ConstructionFormView,
      meta: {
        pageHeader: false,
        sidebarMode: 2,
        allowFullscreen: true,
        userPermission: ['construction', 2],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/constructions/:id',
      name: 'construction-item',
      component: ConstructionItemView,
      meta: {
        pageHeader: false,
        userPermission: ['construction', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/planifications',
      name: 'planification-list',
      component: PlanificationListView,
      meta: {
        pageHeader: false,
        userPermission: ['construction', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/calendar',
      name: 'construction-calendar',
      component: ConstructionCalendarView,
      meta: {
        pageHeader: false,
        userPermission: ['construction', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/technicians/calendar',
      name: 'technicians-calendar',
      component: TechniciansCalendarView,
      meta: {
        pageHeader: false,
        userPermission: ['construction', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/my-planifications',
      name: 'my-planification-list',
      component: MyPlanificationListView,
      meta: {
        pageHeader: false,
        userPermission: ['constructionInterface', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/my-planning',
      name: 'my-planning-planification',
      component: MyCalendarView,
      meta: {
        pageHeader: false,
        userPermission: ['constructionInterface', 1],
        appModule: 'construction'
      }
    },
    {
      path: '/constructions/dashboard',
      name: 'technician-dashboard',
      component: TechnicianDashboardView,
      meta: {
        pageHeader: false,
        title: 'Accueil',
        userPermission: ['constructionInterface', 1],
        appModule: 'construction'
      }
    }
  ]
}

export default routes
